import { BehaviorSubject } from 'rxjs';

export class SharedData {
  private static dataSubject = new BehaviorSubject<string>('nse');
  static data$ = SharedData.dataSubject.asObservable();

  private static symbolSubject = new BehaviorSubject<string>('');
  static symbol$ = SharedData.symbolSubject.asObservable();

  private static exchangeSubject = new BehaviorSubject<string>('');
  static exchange$ = SharedData.exchangeSubject.asObservable();

  private static IBLISTSubject = new BehaviorSubject<string>('');
  static ibList$ = SharedData.IBLISTSubject.asObservable();


  static updateData(value: string) {
    SharedData.dataSubject.next(value);
  }

  static updateSymbol(value: string) {
    SharedData.symbolSubject.next(value);
  }

  static updateBroker(value: string) {
    SharedData.exchangeSubject.next(value);
  }

  static UpdateIBLIST(value: string) {
    SharedData.IBLISTSubject.next(value);
  }
}